import React from "react";
import { Form, Input, Checkbox, Select, Button, Icon, Alert } from "antd";
import { Toggle } from "react-powerplug";

import { valuesAndErrorsToFields } from "../../shared/util/antdForm";

const SessionForm = Form.create()(
  class C extends React.Component {
    state = {
      formErrors: undefined,
    };

    handleSubmit = (e) => {
      const { form, onSubmit } = this.props;

      e.preventDefault();
      form.validateFields(async (err, values) => {
        if (err) {
          return;
        }

        const errors = await onSubmit(values);
        if (!errors) {
          return;
        }

        this.setState({ formErrors: errors["_errors"] });
        form.setFields(valuesAndErrorsToFields(values, errors));
      });
    };

    render() {
      const {
        row,
        licenseSet,
        scenarioSet,
        user,
        loading,
        form: { getFieldDecorator },
      } = this.props;

      const { formErrors } = this.state;

      return (
        <Form onSubmit={this.handleSubmit} autoComplete="off" layout="vertical">
          {formErrors && (
            <Form.Item>
              {formErrors.map((error, index) => (
                <Alert
                  key={index}
                  message={error.toString()}
                  type="error"
                  showIcon
                />
              ))}
            </Form.Item>
          )}

          <Form.Item
            label="pin"
            extra="When left empty, a PIN will be generated for you"
          >
            {getFieldDecorator("pin", {
              initialValue: row.pin,
            })(<Input type="text" placeholder="Please enter a PIN" />)}
          </Form.Item>

          {!row.id && user.isAdmin && (
            <Form.Item label="License">
              {getFieldDecorator("licenseId", {
                rules: [{ required: true, message: "License is required" }],
                validateTrigger: ["onBlur"],
              })(
                <Select placeholder="Select a license">
                  <Select.Option value={null}>---</Select.Option>
                  {licenseSet.map(({ id, name }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          )}

          {!row.id && (
            <Form.Item label="Scenario">
              {getFieldDecorator("scenarioId", {
                rules: [{ required: true, message: "Scenario is required" }],
                validateTrigger: ["onBlur"],
              })(
                <Select placeholder="Select a scenario">
                  <Select.Option value={null}>---</Select.Option>
                  {scenarioSet.map(({ id, name }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          )}

          <Toggle initial={false}>
            {({ on, toggle }) => (
              <Form.Item label="Master password">
                {getFieldDecorator("masterPassword", {
                  rules: [
                    { required: true, message: "Master password is required" },
                  ],
                  validateTrigger: ["onBlur"],
                  initialValue: row.masterPassword,
                })(
                  <Input
                    type={on ? "text" : "password"}
                    placeholder="Please enter a password"
                    prefix={<Icon type="lock" />}
                    suffix={
                      <Icon
                        type={on ? "eye" : "eye-invisible"}
                        onClick={toggle}
                      />
                    }
                  />
                )}
              </Form.Item>
            )}
          </Toggle>

          <Form.Item label="Is active?">
            {getFieldDecorator("isActive", {
              valuePropName: "checked",
              initialValue: row.isActive !== undefined ? row.isActive : false,
            })(<Checkbox>This session is active</Checkbox>)}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save
            </Button>
          </Form.Item>
        </Form>
      );
    }
  }
);

export default SessionForm;
